var _marker, _marker2, _marker3, _marker4, _marker5, _marker6, _marker7, _rect, _rect2, _text, _text2, _line, _text3, _rect3, _text4, _rect4, _text5, _rect5, _text6, _rect6, _text7, _rect7, _text8, _line2, _line3, _line4, _line5, _line6, _rect8, _text9, _rect9, _text0, _text1, _line7, _rect0, _text10, _text11, _line8, _rect1, _text12, _line9, _circle, _text13, _circle2, _text14, _circle3, _text15, _rect10, _text16, _text17, _text18, _text19, _line0, _rect11, _text20, _text21, _text22, _text23, _line1, _line10, _rect12, _text24, _line11, _text25, _text26, _line12, _rect13, _text27, _text28, _text29, _line13, _text30, _line14, _text31, _line15, _text32, _line16, _text33, _line17, _text34;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDanishNeuroDbPipeline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 720,
    viewBox: "0 0 1000 720",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "dc",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#06B6D4"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "dsky",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#7dd3fc"
  }))), _marker3 || (_marker3 = /*#__PURE__*/React.createElement("marker", {
    id: "dv",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#a78bfa"
  }))), _marker4 || (_marker4 = /*#__PURE__*/React.createElement("marker", {
    id: "dg",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#22c55e"
  }))), _marker5 || (_marker5 = /*#__PURE__*/React.createElement("marker", {
    id: "da",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#F59E0B"
  }))), _marker6 || (_marker6 = /*#__PURE__*/React.createElement("marker", {
    id: "do",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#f97316"
  }))), _marker7 || (_marker7 = /*#__PURE__*/React.createElement("marker", {
    id: "dt",
    markerWidth: 8,
    markerHeight: 8,
    refX: 8,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,6 L8,3 z",
    fill: "#10b981"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dbg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#0c1628"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#060c14"
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 720,
    fill: "url(#dbg)",
    rx: 12
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 720,
    fill: "none",
    rx: 12,
    stroke: "rgba(255,255,255,0.06)",
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 36,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 17,
    fontWeight: 700,
    letterSpacing: -0.3
  }, "Danish Neurophysiological Database Architecture")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 54,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 10
  }, "BIDS \xB7 HED-SCORE \xB7 EDF/EDF+ \xB7 FAIR Principles")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 68,
    x2: 960,
    y2: 68,
    stroke: "rgba(255,255,255,0.07)",
    strokeWidth: 1
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 80,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 9,
    fontWeight: 600
  }, "5 Danish Regional Departments \xB7 EEG \xB7 PSG \xB7 MSLT recordings")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 88,
    width: 168,
    height: 40,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 112,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 700
  }, "Region 1")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 236,
    y: 88,
    width: 168,
    height: 40,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 320,
    y: 112,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 700
  }, "Region 2")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 416,
    y: 88,
    width: 168,
    height: 40,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 112,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 700
  }, "Region 3")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 596,
    y: 88,
    width: 168,
    height: 40,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 680,
    y: 112,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 700
  }, "Region 4")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 776,
    y: 88,
    width: 168,
    height: 40,
    rx: 6,
    fill: "#0a1628",
    stroke: "#06B6D4",
    strokeWidth: 1.5
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 860,
    y: 112,
    textAnchor: "middle",
    fill: "#e2e8f0",
    fontSize: 11,
    fontWeight: 700
  }, "Region 5")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: 128,
    x2: 340,
    y2: 172,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    strokeDasharray: "4,3",
    markerEnd: "url(#dc)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 320,
    y1: 128,
    x2: 420,
    y2: 172,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    strokeDasharray: "4,3",
    markerEnd: "url(#dc)"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 128,
    x2: 500,
    y2: 172,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    strokeDasharray: "4,3",
    markerEnd: "url(#dc)"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 680,
    y1: 128,
    x2: 580,
    y2: 172,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    strokeDasharray: "4,3",
    markerEnd: "url(#dc)"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 860,
    y1: 128,
    x2: 660,
    y2: 172,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    strokeDasharray: "4,3",
    markerEnd: "url(#dc)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 164,
    width: 460,
    height: 374,
    rx: 8,
    fill: "rgba(125,211,252,0.02)",
    stroke: "#7dd3fc",
    strokeWidth: 1.5,
    strokeDasharray: "6,4"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 284,
    y: 277,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 8.5,
    fontStyle: "italic",
    transform: "rotate(-90,284,277)"
  }, "Computerome \u2014 secure infrastructure")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 172,
    width: 400,
    height: 56,
    rx: 6,
    fill: "#0a1628",
    stroke: "#7dd3fc",
    strokeWidth: 1.5
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 194,
    textAnchor: "middle",
    fill: "#7dd3fc",
    fontSize: 12,
    fontWeight: 700
  }, "5 Regional Landing Zones")), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 210,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "One per region \xB7 regional legal ownership \xB7 preliminary validation")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 228,
    x2: 500,
    y2: 254,
    stroke: "#7dd3fc",
    strokeWidth: 1.5,
    markerEnd: "url(#dsky)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 254,
    width: 400,
    height: 56,
    rx: 6,
    fill: "#0a1628",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 276,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontSize: 12,
    fontWeight: 700
  }, "Dedicated Workspace")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 292,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9
  }, "Initiative's legal ownership \xB7 prepared for combination")), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 310,
    x2: 500,
    y2: 336,
    stroke: "#a78bfa",
    strokeWidth: 1.5,
    markerEnd: "url(#dv)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 336,
    width: 400,
    height: 96,
    rx: 6,
    fill: "rgba(34,197,94,0.03)",
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 356,
    textAnchor: "middle",
    fill: "#22c55e",
    fontSize: 13,
    fontWeight: 700
  }, "Combined Database")), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 313,
    y1: 364,
    x2: 687,
    y2: 364,
    stroke: "rgba(34,197,94,0.15)",
    strokeWidth: 1
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 375,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 328,
    y: 379,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "BIDS-compliant folder &amp; metadata structure")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 392,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 328,
    y: 396,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "EDF/EDF+ format \xB7 MNE-Python / EEGLAB compatible")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 317,
    cy: 409,
    r: 2.5,
    fill: "#22c55e",
    opacity: 0.7
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 328,
    y: 413,
    fill: "#cbd5e1",
    fontSize: 9.5
  }, "HED-SCORE schema \xB7 machine-readable annotations")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 336,
    width: 230,
    height: 96,
    rx: 6,
    fill: "rgba(249,115,22,0.05)",
    stroke: "#f97316",
    strokeWidth: 1.5,
    strokeDasharray: "5,3"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 358,
    textAnchor: "middle",
    fill: "#fb923c",
    fontSize: 11,
    fontWeight: 700
  }, "National Health Registers")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 378,
    textAnchor: "middle",
    fill: "#a05a30",
    fontSize: 9
  }, "Danish Health Data Authority")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 394,
    textAnchor: "middle",
    fill: "#a05a30",
    fontSize: 9
  }, "Diagnoses \xB7 treatments \xB7 outcomes")), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 135,
    y: 412,
    textAnchor: "middle",
    fill: "#78530a",
    fontSize: 8,
    fontStyle: "italic"
  }, "(pending ethical &amp; legal approval)")), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 250,
    y1: 384,
    x2: 298,
    y2: 384,
    stroke: "#f97316",
    strokeWidth: 1.5,
    strokeDasharray: "4,3",
    markerEnd: "url(#do)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 750,
    y: 336,
    width: 230,
    height: 96,
    rx: 6,
    fill: "rgba(245,158,11,0.05)",
    stroke: "#F59E0B",
    strokeWidth: 1.5
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 865,
    y: 358,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 11,
    fontWeight: 700
  }, "Clinical Annotation Standards")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 865,
    y: 378,
    textAnchor: "middle",
    fill: "#78530a",
    fontSize: 9
  }, "ILAE \u2014 seizure classification")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 865,
    y: 394,
    textAnchor: "middle",
    fill: "#78530a",
    fontSize: 9
  }, "AASM \u2014 sleep-stage &amp; event scoring")), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 865,
    y: 412,
    textAnchor: "middle",
    fill: "#78530a",
    fontSize: 8,
    fontStyle: "italic"
  }, "Standardized, clinically validated labels")), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 750,
    y1: 384,
    x2: 702,
    y2: 384,
    stroke: "#F59E0B",
    strokeWidth: 1.5,
    markerEnd: "url(#da)"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 432,
    x2: 500,
    y2: 454,
    stroke: "#22c55e",
    strokeWidth: 1.5,
    markerEnd: "url(#dg)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 454,
    width: 400,
    height: 76,
    rx: 6,
    fill: "rgba(245,158,11,0.04)",
    stroke: "#F59E0B",
    strokeWidth: 1.5
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 474,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 12,
    fontWeight: 700
  }, "Access &amp; Governance")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 313,
    y1: 482,
    x2: 687,
    y2: 482,
    stroke: "rgba(245,158,11,0.15)",
    strokeWidth: 1
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 498,
    textAnchor: "middle",
    fill: "#cbd5e1",
    fontSize: 9
  }, "Governing Board reviews &amp; approves each access request")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 514,
    textAnchor: "middle",
    fill: "#cbd5e1",
    fontSize: 9
  }, "Researchers work inside the secure environment \u2014 no raw data export")), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 500,
    y1: 530,
    x2: 500,
    y2: 566,
    stroke: "#10b981",
    strokeWidth: 1.5,
    markerEnd: "url(#dt)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 568,
    width: 300,
    height: 54,
    rx: 6,
    fill: "rgba(16,185,129,0.06)",
    stroke: "#10b981",
    strokeWidth: 1.5
  })), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 588,
    textAnchor: "middle",
    fill: "#34d399",
    fontSize: 11,
    fontWeight: 700
  }, "De-Identified Model Outputs")), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 604,
    textAnchor: "middle",
    fill: "#0d6e52",
    fontSize: 9
  }, "Only outputs ever leave the secure environment")), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 646,
    textAnchor: "middle",
    fill: "#475569",
    fontSize: 9.5
  }, "Every stage designed around the FAIR principles \u2014 Findability \xB7 Accessibility \xB7 Interoperability \xB7 Reusability")), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 672,
    x2: 60,
    y2: 672,
    stroke: "#06B6D4",
    strokeWidth: 1.5,
    strokeDasharray: "4,3"
  })), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 676,
    fill: "#475569",
    fontSize: 9
  }, "SFTP transfer")), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 672,
    x2: 220,
    y2: 672,
    stroke: "#7dd3fc",
    strokeWidth: 1.5,
    strokeDasharray: "6,4"
  })), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    x: 226,
    y: 676,
    fill: "#475569",
    fontSize: 9
  }, "Secure infrastructure boundary")), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 440,
    y1: 672,
    x2: 460,
    y2: 672,
    stroke: "#22c55e",
    strokeWidth: 1.5
  })), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    x: 466,
    y: 676,
    fill: "#475569",
    fontSize: 9
  }, "Combined database")), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 696,
    x2: 60,
    y2: 696,
    stroke: "#f97316",
    strokeWidth: 1.5,
    strokeDasharray: "4,3"
  })), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    x: 66,
    y: 700,
    fill: "#475569",
    fontSize: 9
  }, "Pending registry linkage")), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 696,
    x2: 260,
    y2: 696,
    stroke: "#F59E0B",
    strokeWidth: 1.5
  })), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    x: 266,
    y: 700,
    fill: "#475569",
    fontSize: 9
  }, "Governance &amp; standards")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanishNeuroDbPipeline);
export default __webpack_public_path__ + "static/media/danish-neuro-db-pipeline.0b0b261f403b7a1332064cb454617142.svg";
export { ForwardRef as ReactComponent };